<template>
  <div class="">
    <delivery-form title="به روزرسانی نرخ" :submitFunction="updateDelivery"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import DeliveryForm from "./DeliveryForm";

export default {
  name: "UpdateDelivery",
  components: {DeliveryForm},
  methods: {
    ...mapActions({
      updateDelivery: "Delivery/updateDelivery"
    })
  }
}
</script>

<style scoped>

</style>